import { Link as _Link } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const Link = _Link;

/**
 *
 * A Link for use when we need react-router
 */
const CUIRouterLink = /*#__PURE__*/forwardRef((args, ref) => {
  return /*#__PURE__*/_jsx(Link, Object.assign({
    as: RouterLink
  }, args, {
    ref: ref
  }));
});

/**
 *
 * Links for tabs need to be passed using an 'an' prop that doesn't take a variant
 * This routerLink is used for tabs to act as
 */
export const CUITabRouterLink = /*#__PURE__*/forwardRef((args, ref) => {
  return /*#__PURE__*/_jsx(CUIRouterLink, Object.assign({}, args, {
    ref: ref,
    variant: "tabsLink"
  }));
});
export default CUIRouterLink;